import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledCardHeader = styled(Flexer.Parent)`
  border-bottom: 1px solid var(--greyMouse);
`;

export default StyledCardHeader;
